export default {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: true,
  y: false
}



// WEBPACK FOOTER //
// ./src/config/scroll-to.js